import { t } from '@lingui/core/macro';
import { DialogHeader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function DuplicateDialogHeader(props) {
    const { testId, title } = props;
    return (<DialogHeader data-testid={testId} title={title ||
            t({
                message: 'Create document copy',
                comment: 'Duplicate document dialog title',
            })} icon={<Falcon icon="copy"/>}/>);
}
